module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"tr":{"date-error":"Önceki verinin tarihinden eski tarih girilemez!","unexpectedError":"Beklenmeyen bir hata oluştu!","formCreateMsg":"Form oluşturuluyor. Lütfen bekleyin.","saveForm":"Formu kaydetmek için \u0027Oluştur\u0027 butonuna tıklayın"},"en":{"date-error":"Entering an older date than previous dates is not allowed!","unexpectedError":"An unexpected error ocurred!","formCreateMsg":"Form is being created. Please wait.","saveForm":"Click the \u0027Create\u0027 button to save the form"}}')
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./node_modules/vue-loader/lib/selector.js?type=customBlocks&index=1!./src/views/Doc/Forms/FormCreate.vue
// module id = IZka
// module chunks = 1